import { AfterViewInit, ChangeDetectorRef, Component, model } from '@angular/core';
import { User } from '../../../models/user';
import { Division } from '../../../models/division';
import { Area } from '../../../models/area';
import { Role } from '../../../models/rol';
import { SignatureDivisionArea } from '../../../models/signature-division-area';
import { provideNativeDateAdapter } from '@angular/material/core';
import { NgForm } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { addUserAct, findAllRolesAct, findUserAct, resetUserAct, updateUserAct } from '../../../store/users/users.actions';
import { findAreasCatalogAct, findDivisionsCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';
import { filter, map, combineLatest, shareReplay, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-user-add',
  standalone: false,
  templateUrl: './user-add.component.html',
  styleUrl: './user-add.component.css',
  providers: [provideNativeDateAdapter()]
})
export class UserAddComponent implements AfterViewInit{
  user: User= new User();
  areas: Area[] = [];
  divisions: Division[] = [];
  violations: any;
  roles!: Role[];
  userForm!: NgForm;
  loading: boolean = true;
  isRolAut: boolean = false;

  readonly checked = model(false);
  readonly indeterminate = model(false);

  ngAfterViewInit() {
    
  }

  ngOnInit(): void {
    this.userStore.dispatch(resetUserAct());
    this.userStore.dispatch(findAllRolesAct());
    this.catalogOfferStore.dispatch(findDivisionsCatalogAct());
    this.catalogOfferStore.dispatch(findAreasCatalogAct());
  
    this.route.paramMap.subscribe(params => {
      const id: number = +(params.get('id') || '0');
      if (id > 0) {
        this.userStore.dispatch(findUserAct({ id }));
      }else{
        this.user = new User();
        this.user.active = true;
      }
    });
  
    //this.suscribirseADatos(); // <-- método aparte que contiene el combineLatest
  }

  constructor(
    private userStore: Store<{ usersRdc: any }>,
    private route: ActivatedRoute,
    private catalogOfferStore: Store<{ catalogOfferRdc: any }>,
    private cd: ChangeDetectorRef
  ) {
    this.user = new User();
    this.violations = [];
    this.suscribirseADatos(); // <-- método aparte que contiene el combineLatest

  }

  private suscribirseADatos(): void {
    const users$ = this.userStore.pipe(
      select('usersRdc'),
      map(state => ({
        user: state.user,
        violations: state.violations,
        loading: state.loading,
        roles: state.roles
      })),
      shareReplay(1)
    );
  
    const catalog$ = this.catalogOfferStore.pipe(
      select('catalogOfferRdc'),
      map(state => ({
        divisions: state.divisions,
        areas: state.areas
      })),
      //filter(data => data.divisions.length > 0 && data.areas.length > 0),
      shareReplay(1)
    );
  
    combineLatest([users$, catalog$]).subscribe(([userData, catalogData]) => {
  
      this.violations = userData.violations;
      this.user = userData.user ? JSON.parse(JSON.stringify(userData.user)) : new User();
      this.loading = userData.loading;
      this.roles = userData.roles ? JSON.parse(JSON.stringify(userData.roles)) : [];
      this.divisions = catalogData.divisions;
      this.areas = catalogData.areas;
  
      this.roles.forEach(role => {
        role.checked = this.user?.roles?.some(r => r.id === role.id) || false;
      });
      this.isRolAutCheck();
  
      if (this.userForm) {
        for (const controlName in this.userForm.controls) {
          const control = this.userForm.controls[controlName];
          if (this.violations[controlName]) {
            control.setErrors({ 'incorrect': true });
          }
        }
      }
  
      if (this.divisions.length > 0 && this.areas.length > 0) {
        this.mergeSignatureDivisionAreas();
      }
  
      this.cd.markForCheck();
    });
  }

  onSubmit(userForm: NgForm): void {
    this.loading = true;
    this.userForm = userForm;
    const userCopy = JSON.parse(JSON.stringify(this.user));

    userCopy.person.email = userCopy.email;
    userCopy.roles = [];
    this.roles.forEach((role) => {
      if(role.checked){
        userCopy.roles.push({
          id: role.id, name: role.name, description: '', checked: false
        });
      }
    });

    const sdaSelect = userCopy.signatureDivisionAreas.filter((sda: SignatureDivisionArea) => sda.selected);
    //console.log('Seleccionadas: ', sdaSelect);

    userCopy.signatureDivisionAreas = sdaSelect;

    if (userCopy.id > 0) {
      this.userStore.dispatch(updateUserAct({ userUpdated: userCopy }));
    } else {
      this.userStore.dispatch(addUserAct({userNew: userCopy}));
    }
  }

  private mergeSignatureDivisionAreas() {
    const merged: SignatureDivisionArea[] = [];
  
    for (let division of this.divisions) {
      for (let area of this.areas) {
        // Verificar si esta combinación ya existe en user.signatureDivisionAreas
        const existing = this.user.signatureDivisionAreas.find(sda =>
          sda.division.id === division.id && sda.area.id === area.id
        );
  
        if (existing) {
          merged.push({ ...existing, selected: true });
        } else {
          merged.push({
            id: {
              signatureUserId: this.user.id,
              divisionId: division.id,
              areaId: area.id,
            },
            division,
            area,
            selected: false,
          });
        }
      }
    }
  
    this.user.signatureDivisionAreas = merged;
  }

  onCheckboxChange(sda: SignatureDivisionArea, event: any) {
    sda.selected = event.target.checked;
  }

  getSDA(divisionId: number, areaId: number): SignatureDivisionArea {
    return this.user.signatureDivisionAreas.find(
      sda => sda.division.id === divisionId && sda.area.id === areaId
    )!;
  }
  
  isSelected(divisionId: number, areaId: number): boolean {
    const sda = this.getSDA(divisionId, areaId);
    return sda?.selected || false;
  }

  hoveredRow: number | null = null;
  hoveredCol: number | null = null;
  
  onMouseEnter(rowIndex: number, colIndex: number): void {
    this.hoveredRow = rowIndex;
    this.hoveredCol = colIndex;
  }
  
  onMouseLeave(): void {
    this.hoveredRow = null;
    this.hoveredCol = null;
  }

  isRolAutCheck(){
    this.isRolAut = this.roles?.some(r => r.name === 'ROL_AUT' && r.checked == true) || false;
  }
}
